import React from "react";

import FalconCloseButton from "components/common/FalconCloseButton";
import Flex from "components/common/Flex";
import Lottie from "lottie-react";
import paths from "routes/paths";
import { Button, Col, Form, Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import MultiSelect from "components/common/MultiSelect";
import { useDispatch } from "react-redux";
import {
  CreateClaimFromPreauth,
  CreateSingleClaim,
} from "features/cliams/config/cliamApi";
import {
  handleResetClaimAll,
  handleResetCreateClaim,
} from "features/cliams/config/claimSlice";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
const ClaimBatchCreateCLiamFromPreauthModal = ({
  modal,
  setModal,
  data,
  body,
  setClaimNo,
  setBody,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { control, handleSubmit, watch, setValue, reset } = useForm({
    defaultValues: {
      claim_batch: "",
    },
  });

  const handleCreateInExisting = async (data) => {
    const claimNo = data?.claim_batch?.claimbatch_no;

    setClaimNo(claimNo);

    const updatedBody = {
      ...body,
      claimbatch_no: claimNo,
    };

    setBody(updatedBody);

    const response = await dispatch(
      CreateClaimFromPreauth(updatedBody)
    ).unwrap();
    if (response?.success) {
      toast.success(response?.message_en);
      navigate(paths.claimsList);
      dispatch(handleResetCreateClaim());
      dispatch(handleResetClaimAll());
    } else {
      toast.error(response?.message_en);
    }
  };

  const handleCreateNew = async () => {
    setClaimNo(""); // clear UI state (optional)

    // Remove claimbatch_no from the body
    const { claimbatch_no, ...updatedBody } = body;

    setBody(updatedBody);

    const response = await dispatch(CreateSingleClaim(updatedBody)).unwrap();

    if (response?.success) {
      toast.success(response?.message_en);
      navigate(paths.claimsList);
      dispatch(handleResetCreateClaim());
    } else {
      toast.error(response?.message_en);
    }
  };

  return (
    <Modal
      show={modal}
      onHide={() => {
        setModal(false);
        reset();
        setClaimNo(null);
        setValue("claim_batch", "");
      }}
      centered
      dialogClassName="wizard-modal"
    >
      <Modal.Body>
        <FalconCloseButton
          size="sm"
          className="position-absolute top-0 end-0 me-2 mt-2"
          onClick={() => {
            setModal(false);
            reset();
            setValue("claim_batch", "");
            setClaimNo(null);
          }}
        />
        <Flex direction="column" alignItems="center" className="mb-3">
          <h6 className="fs-9 text-700">Create Claim</h6>
          <h6 className="fs-11 text-400 ">
            There is/are already batche(s) created for this period. Choose to
            add new claim(s) to existing batch? Or create new one?
          </h6>
        </Flex>
        <Form noValidate onSubmit={handleSubmit(handleCreateInExisting)}>
          <Col xs={12} className="mx-auto">
            <label className="form-label">
              Cliam Batch <span className="text-danger">*</span>
            </label>
            <Controller
              name="claim_batch"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <MultiSelect
                  {...field}
                  menuPlacement="auto"
                  closeMenuOnSelect={true}
                  isMulti={false}
                  options={data?.map((item) => ({
                    value: item.claimbatch_id,
                    label: item.claimbatch_no,
                  }))}
                  value={
                    field.value
                      ? {
                          value: field.value.claimbatch_id,
                          label: field.value.claimbatch_no,
                        }
                      : null
                  }
                  onChange={(selected) => {
                    setValue(
                      "claim_batch",
                      selected
                        ? {
                            claimbatch_id: selected.value,
                            claimbatch_no: selected.label,
                          }
                        : null
                    );
                  }}
                  formatOptionLabel={({ label, value }) => (
                    <div>
                      ({value}) - {label}
                    </div>
                  )}
                  getOptionValue={(option) => option.value}
                  placeholder="Choose ..."
                />
              )}
            />
          </Col>
          <hr />
          <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
            <Button variant="danger" size="sm" type="submit">
              Add to existing batch
            </Button>
            <Button variant="success" size="sm" onClick={handleCreateNew}>
              Add to new batch
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ClaimBatchCreateCLiamFromPreauthModal;
